// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination } from 'swiper';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);

// init Swiper:
const BlogSwiper = new Swiper('.swiper--blog', {
  // Optional parameters
  watchOverflow: true,
  slidesPerView: 1,
  breakpoints : {
    768: {
      slidesPerView: 2,
    },
    1040 : {
      slidesPerView: 3,
      spaceBetween: 25
    }
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  }
});
